const CHUNK_ERROR_MESSAGES = [
  'ChunkLoadError',
  String.raw`Loading chunk \d+ failed`,
  'Loading CSS chunk',
  'Importing a module script failed',
];

const CHUNK_ERROR_PATTERN = new RegExp(CHUNK_ERROR_MESSAGES.join('|'), 'i');

export const RELOAD_FLAG = 'chunkReloadAttempted';

export const isChunkLoadError = (error: Error): boolean => (
  error?.name === 'ChunkLoadError' || CHUNK_ERROR_PATTERN.test(error?.message ?? '')
);

/**
 * A deploy removes the previous build's chunks, so a tab opened before it gets a 404
 * on every lazy route it has not visited yet. One reload picks up the current shell.
 * The flag makes it one-shot per tab — a genuinely broken build must not loop.
 */
export const shouldReloadAfterChunkError = (error: Error): boolean => {
  if (!isChunkLoadError(error)) {
    return false;
  }

  try {
    if (window.sessionStorage.getItem(RELOAD_FLAG)) {
      return false;
    }

    window.sessionStorage.setItem(RELOAD_FLAG, '1');
  } catch {
    // storage unavailable (private mode, blocked cookies) — reloading once is still better
  }

  return true;
};
